<template>
  <div>
    <label for="color-picker">{{ label }}</label>
    <div class="button-primary-color-picker">
      <input
        type="color"
        :name="name"
        class="button-primary-color-picker__native"
        :value="normalizedColor"
        :disabled="disabled"
        id="color-picker"
        @input="handleColorInput"
      />
      <v-text-field
        :value="value"
        small
        dense
        :disabled="disabled"
        @input="handleTextInput"
        style="flex: 1"
        hide-details
        class="mt-0 mb-0"
      />
      <v-btn small text color="primary" :disabled="disabled" @click="handleReset">Reset</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorPicker',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Color',
    },
    name: {
      type: String,
      default: 'color',
    },
    defaultColor: {
      type: String,
      default: '#ffffff',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedColor() {
      return this.normalizeHexColor(this.value, this.defaultColor);
    },
  },
  methods: {
    normalizeHexColor(color, fallback = '#ffffff') {
      if (typeof color !== 'string') return fallback;

      const normalized = color.trim();
      const hex3 = /^#([a-fA-F0-9]{3})$/;
      const hex6 = /^#([a-fA-F0-9]{6})$/;

      if (hex6.test(normalized)) return normalized;
      if (hex3.test(normalized)) {
        const short = normalized.slice(1);
        return `#${short
          .split('')
          .map(char => `${char}${char}`)
          .join('')}`;
      }

      return fallback;
    },
    handleColorInput(event) {
      this.$emit('input', event.target.value);
    },
    handleTextInput(nextValue) {
      this.$emit('input', nextValue);
    },
    handleReset() {
      const resetColor = this.normalizeHexColor(this.defaultColor, '');
      this.$emit('input', resetColor);
      this.$emit('reset', resetColor);
    },
  },
};
</script>

<style scoped>
.button-primary-color-picker {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-primary-color-picker__native {
  width: 43px;
  height: 43px;
}
</style>
